import React from "react";
import { Box, Typography, Input, Slider } from "@mui/material";
import { getColor } from "../../style/color/color";
import { fonts } from "../../style/fonts/fonts";

const AgeSlider = ({ question, totalAge, onAgeChange }) => {
  const handleAgeChange = (e) => {
    const value = e.target.value;

    // Ensure the value is a valid positive integer and not empty
    if (/^\d+$/.test(value) || value === "") {
      onAgeChange(value);
    }
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: getColor.NeutralDark700,
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: "700",
            mt: "30px",
          }}
        >
          {question}
        </Typography>
        <Input
          type="tel"
          disableUnderline={true}
          sx={{
            borderRadius: 3,
            border: "1px solid black",
            p: 1,
            mt: "15px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: getColor.NeutralDark700,
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: 700,
            wordWrap: "break-word",
            ".MuiInput-underline": {
              "&:before": {
                borderBottom: "none",
              },
              "&:after": {
                borderBottom: "none",
              },
            },
            "& input": {
              textAlign: "center",
              fontWeight: "600",
            },
          }}
          value={totalAge}
          onChange={handleAgeChange}
          inputProps={{
            pattern: "^[0-9]+$",
          }}
        ></Input>
      </Box>
      <Slider
        aria-labelledby="input-slider"
        valueLabelDisplay="auto"
        value={Number(totalAge) || 0}
        onChange={(e, newValue) => {
          onAgeChange(e.target.value);
        }}
        min={1}
        max={25}
        step={1}
        sx={{
          width: "90%",
          p: 1,
          mt: "10px",
          mr: "10px",
          ml: "10px",
          color: getColor.ExtendedpalettesSummerSkySS800,
          "& .MuiSlider-thumb": {
            height: 24,
            width: 24,
            backgroundColor: getColor.PrimaryWhite,
            border: "2px solid currentColor",
            "&:hover": {
              boxShadow: "inherit",
            },
          },
          "& .MuiSlider-track": {
            height: 8,
            borderRadius: 4,
          },
          "& .MuiSlider-rail": {
            height: 8,
            borderRadius: 4,
            backgroundColor: "rgba(0, 0, 0, 0.10)",
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ml: "12px",
          mr: "12px",
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          {`${1} yr`}
        </Typography>

        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          {`${25} yrs`}
        </Typography>
      </Box>
    </>
  );
};

export default AgeSlider;
